import { render } from "./WechatPayment.vue?vue&type=template&id=7e44e642&scoped=true"
import script from "./WechatPayment.vue?vue&type=script&lang=js"
export * from "./WechatPayment.vue?vue&type=script&lang=js"

import "./WechatPayment.vue?vue&type=style&index=0&id=7e44e642&scoped=true&lang=css"

import exportComponent from "/Users/alvinpascasio/pjf-wine-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e44e642"]])

export default __exports__